import { applyMiddleware, combineReducers, createStore } from 'redux';
import { createLogicMiddleware } from 'redux-logic';

import { authReducers, ReduxLogic } from 'common/auth/auth_context';

export const store = createStore(
    combineReducers({
        auth: authReducers,
    }),
    applyMiddleware(createLogicMiddleware([...ReduxLogic]))
);

export type RootState = ReturnType<typeof store.getState>;
